module.exports = __webpack_public_path__ + "img/nolan-html.1af332b8.svg";